"use client";

import { ArrowRight } from "lucide-react";

interface BrandSuggestionCardProps {
  brandName: string;
  subheading?: string;
  onNavigate: () => void;
}

/**
 * Reusable brand suggestion card for search results
 * Horizontal layout: black brand box on left, description + learn more on right
 */
export function BrandSuggestionCard({
  brandName,
  subheading,
  onNavigate,
}: BrandSuggestionCardProps) {
  return (
    <div
      className="group flex cursor-pointer items-stretch overflow-hidden rounded-xl border border-divider bg-white transition-all duration-300 hover:border-divider-dark hover:shadow-sm"
      onClick={onNavigate}
    >
      {/* Black brand name box on the left - wider for longer names */}
      <div className="flex w-36 flex-shrink-0 items-center justify-center rounded-l-xl bg-ink px-4 py-6 md:w-40">
        <span className="text-center text-body font-medium leading-tight text-white">
          {brandName}
        </span>
      </div>

      {/* Content area on the right - stacked vertically */}
      <div className="flex flex-1 flex-col justify-center gap-4 px-5 py-6 md:px-8 md:py-7">
        {/* Description / Subheading */}
        {subheading ? (
          <p className="text-body leading-relaxed text-ink-secondary">{subheading}</p>
        ) : (
          <p className="text-body text-ink-muted">Discover {brandName}&apos;s collection</p>
        )}

        {/* Learn more link - now below description */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNavigate();
          }}
          className="inline-flex w-fit items-center gap-1.5 text-caption text-ink-muted transition-all duration-200 hover:text-ink hover:underline"
        >
          <span>learn more</span>
          <ArrowRight size={12} />
        </button>
      </div>
    </div>
  );
}
